<template>
  <div>
    <!-- ================= HEADER ================= -->
    <header class="fixed-top bg-white border-bottom border-secondary" style="padding-left:20px;padding-right:20px">
      <div class="container d-flex justify-content-between align-items-center py-3">
        <a
          href="#"
          class="text-dark fw-bold text-decoration-none d-flex align-items-center gap-2"
        >
          <img
            src="@/assets/MGTSPL_LOGO.png"
            alt="Marine-Group Transport Services"
            class="logo-img"
          />
          <span>Marine-Group Transport Services</span>
        </a>


        <nav class="d-none d-md-flex gap-4">
          <a href="#services" class="text-dark text-decoration-none">Services</a>
          <a href="#why-us" class="text-dark text-decoration-none">Why Us</a>
          <a href="#industries" class="text-dark text-decoration-none">Industries</a>
          <a
            href="/login"
            class="text-dark text-decoration-none fw-semibold"
          >
            Login
          </a>
        </nav>

        <button class="btn btn-outline-info d-md-none" @click="menuOpen = !menuOpen">
          <Menu v-if="!menuOpen" />
          <X v-else />
        </button>
      </div>

      <div v-if="menuOpen" class="bg-white border-top border-secondary p-3">
        <a class="d-block text-dark mb-2" href="#services" @click="menuOpen=false">Services</a>
        <a class="d-block text-dark mb-2" href="#why-us" @click="menuOpen=false">Why Us</a>
        <a class="d-block text-dark mb-2" href="#industries" @click="menuOpen=false">Industries</a>
        <a
            href="/login"
            class="text-dark text-decoration-none fw-semibold"
          >
            Login
          </a>
      </div>
    </header>

    <!-- ================= HERO ================= -->
    <section class="hero-bg text-light d-flex align-items-center">
      <div class="container text-center hero-content">
        <span class="badge rounded-pill bg-secondary px-3 py-2 mb-4">
          Trusted by leading shipping companies
        </span>

        <h1 class="display-4 fw-bold">
          Reliable Crew Transportation You Can
          <span class="text-info"> Count On</span>
        </h1>

        <p class="lead mt-3 text-light opacity-75">
          Safe, punctual, and professional transport for ship crews.
          From port to vessel, airport to dock — we deliver your crew on time, every time.
        </p>

        <div class="d-flex justify-content-center gap-4 my-4 flex-wrap text-info">
          <div class="d-flex align-items-center gap-2">
            <Clock :size="18" /> 24/7 Operations
          </div>
          <div class="d-flex align-items-center gap-2">
            <Shield :size="18" /> On-Time Guarantee
          </div>
          <div class="d-flex align-items-center gap-2">
            <MapPin :size="18" /> All Major Ports
          </div>
        </div>

        <div class="d-flex justify-content-center gap-3 flex-wrap">
          <a
            href="https://wa.me/6592992010"
            target="_blank"
            class="btn btn-info btn-lg px-4 d-inline-flex align-items-center gap-2"
          >
            Contact Us 
            <ArrowRight :size="18" />
          </a>

          <a href="#services" class="btn btn-outline-light btn-lg px-4">
            View Services
          </a>
        </div>
      </div>

      
    </section>

 <!-- ================= SERVICES ================= -->
<section id="services" class="py-5 bg-light" style="padding-left:40px;padding-right:40px">
  <div class="container">

    <!-- section header -->
    <div class="text-center mb-5">
      <div class="text-info fw-semibold small mb-2">
        OUR SERVICES
      </div>
      <h2 class=" display-5 fw-bold mb-3">
        Comprehensive Crew Transport Solutions
      </h2>
      <p class="text-muted mx-auto" style="max-width:720px">
        From airport pickups to vessel boarding, we handle every aspect of maritime
        crew transportation with precision and care.
      </p>
    </div>

    <!-- cards -->
    <div class="row g-4">
      <div
        class="col-lg-4 col-md-6"
        v-for="s in services"
        :key="s.title"
      >
        <div class="card h-100 border-0 shadow-sm rounded-4">
          <div class="card-body p-4">

            <!-- icon box -->
            <div
              class="d-inline-flex align-items-center justify-content-center
                     bg-light rounded-3 mb-4"
              style="width:48px;height:48px"
            >
              <component :is="s.icon" class="text-info" :size="22" />
            </div>

            <h5 class="fw-semibold mb-2">
              {{ s.title }}
            </h5>

            <p class="text-muted mb-0">
              {{ s.desc }}
            </p>

          </div>
        </div>
      </div>
    </div>

  </div>
</section>


<!-- ================= FLEET ================= -->
<section class="py-5 bg-white" style="padding-left:20px;padding-right:20px">
  <div class="container">

    <!-- header -->
    <div class="text-center mb-5">
      <div class="text-info fw-semibold small mb-2">OUR FLEET</div>
      <h2 class="display-5 fw-bold mb-3">
        Modern, Well-Maintained Vehicles
      </h2>
      <p class="text-muted mx-auto" style="max-width:720px">
        Our fleet is regularly serviced and maintained to ensure safe, comfortable
        transportation for your crew.
      </p>
    </div>

    <div class="row g-4">
      <div class="col-md-6">
        <div class="card shadow-sm rounded-4 overflow-hidden h-100">
          <div class="fleet-img">
            <img :src="fleetVan" alt="Toyota HiAce" />
          </div>
          <div class="card-body p-4">
            <h5 class="fw-semibold mb-1">Toyota HiAce Commuter</h5>
            <p class="text-muted mb-0">Up to 14 passengers</p>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card shadow-sm rounded-4 overflow-hidden h-100">
          <div class="fleet-img">
            <img :src="fleetAlphard" alt="Toyota Alphard" />
          </div>
          <div class="card-body p-4">
            <h5 class="fw-semibold mb-1">Toyota Alphard</h5>
            <p class="text-muted mb-0">Up to 7 passengers</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>


<!-- ================= WHY US ================= -->
<section id="why-us" class="py-5 bg-light" style="padding-left:40px;padding-right:40px">
  <div class="container">
    <div class="row align-items-start g-5">

      <!-- LEFT SIDE -->
      <div class="col-lg-6">
        <div class="text-info fw-semibold small mb-2">
          WHY CHOOSE US
        </div>

        <h2 class="display-5 fw-bold mb-4">
          Trusted by the Maritime Industry
        </h2>

        <p class="text-muted mb-4">
          With years of experience serving the maritime sector, we understand the
          unique demands of crew transportation. Our commitment to reliability,
          safety, and professionalism makes us the preferred choice for ship owners,
          managers, and crewing agencies worldwide.
        </p>

        <!-- stats -->
        <div class="d-flex gap-5 mt-4">
          <div>
            <div class="display-6 fw-bold">15+</div>
            <div class="text-muted small">Years Experience</div>
          </div>
          <div>
            <div class="display-6 fw-bold">50K+</div>
            <div class="text-muted small">Crew Transported</div>
          </div>
          <div>
            <div class="display-6 fw-bold">25+</div>
            <div class="text-muted small">Ports Served</div>
          </div>
        </div>
      </div>

      <!-- RIGHT SIDE -->
      <div class="col-lg-6">
        <div class="row g-4">
          <div
            class="col-md-6"
            v-for="w in whyUs"
            :key="w.title"
          >
            <div class="bg-white rounded-4 p-4 h-100 shadow-sm">

              <div
                class="d-inline-flex align-items-center justify-content-center
                       bg-light bg-opacity-5 rounded-3 mb-3"
                style="width:44px;height:44px"
              >
                <component :is="w.icon" class="text-info" :size="20" />
              </div>

              <h6 class="fw-semibold mb-2">
                {{ w.title }}
              </h6>

              <p class="text-muted small mb-0">
                {{ w.desc }}
              </p>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<!-- ================= INDUSTRIES ================= -->
<section
  id="industries"
  class="py-5 text-light industries-bg" style="padding-left:40px;padding-right:40px"
>
  <div class="container">

    <!-- header -->
    <div class="text-center mb-5">
      <div class="text-info fw-semibold small mb-2">
        INDUSTRIES WE SERVE
      </div>
      <h2 class="display-5 fw-bold mb-3">
        Serving the Global Maritime Industry
      </h2>
      <p class="text-light opacity-75 mx-auto" style="max-width:720px">
        From commercial shipping to specialized offshore operations, we provide
        tailored transport solutions for every vessel type.
      </p>
    </div>

    <!-- cards -->
    <div class="row g-4">
      <div
        class="col-lg-3 col-md-6"
        v-for="i in industries"
        :key="i.title"
      >
        <div class="industry-card h-100 p-4 text-center">

          <div
            class="industry-icon mx-auto mb-4 d-flex
                   align-items-center justify-content-center"
          >
            <component :is="i.icon" :size="28" />
          </div>

          <h6 class="fw-semibold mb-2">
            {{ i.title }}
          </h6>

          <p class="small text-light opacity-75 mb-0">
            {{ i.desc }}
          </p>

        </div>
      </div>
    </div>

  </div>
</section>


    <!-- ================= FOOTER ================= -->
    <footer class="bg-dark text-secondary py-4 text-center">
      ©2026 Marine-Group Transport Services Pte Ltd
    </footer>
  </div>
</template>

<script setup>
import { ref } from "vue";
import {
  Anchor, Menu, X, ArrowRight, Clock, MapPin, Shield,
  Plane, Ship, Users, ArrowLeftRight, Headphones,
  Container, Waves,Car,CalendarCheck,
  ShieldCheck,
  BadgeCheck,
} from "lucide-vue-next";

import fleetVan from "@/assets/hiace.png";
import fleetAlphard from "@/assets/alphard.png";

const menuOpen = ref(false);

const services = [
  { icon: ArrowLeftRight, title: "Crew Change Transportation", desc: "Seamless on-signer and off-signer crew transfers coordinated with vessel schedules." },
  { icon: Plane, title: "Airport to Port Transfers", desc: "Reliable pickups from airports with real-time flight monitoring and flexible scheduling." },
  { icon: Ship, title: "Port to Vessel Transfers", desc: "Direct transport to vessel berths with full knowledge of port security procedures." },
  { icon: Users, title: "Crew Handling Services", desc: "Complete on-signer/off-signer management including documentation and coordination." },
  { icon: Clock, title: "Emergency Transport", desc: "Short-notice and emergency crew transport available 24/7 for urgent situations." },
  { icon: Car, title: "Multi-Port Coverage", desc: "Extensive network covering major ports with consistent service standards." }
];


const whyUs = [
  {
    icon: Headphones,
    title: "24/7 Operations",
    desc: "Round-the-clock availability for all transport needs, any day of the year."
  },
  {
    icon: Users,
    title: "Maritime-Experienced Drivers",
    desc: "Our team understands port protocols, vessel schedules, and crew requirements."
  },
  {
    icon: CalendarCheck,
    title: "Punctual Scheduling",
    desc: "Precise timing coordinated with flight arrivals, vessel ETAs, and crew rotations."
  },
  {
    icon: ShieldCheck,
    title: "Safety-First Vehicles",
    desc: "Modern, well-maintained fleet meeting all safety and comfort standards."
  },
  {
    icon: BadgeCheck,
    title: "Port Security Cleared",
    desc: "Drivers familiar with port access procedures and security requirements."
  },
  {
    icon: Clock,
    title: "On-Time Guarantee",
    desc: "We understand that crew changes run on tight schedules. We don’t miss deadlines."
  }
];


const industries = [
  { icon: Ship, title: "Shipping", desc: "Commercial fleets" },
  { icon: Anchor, title: "Offshore", desc: "Platform vessels" },
  { icon: Waves, title: "Tankers", desc: "Bulk & tanker ops" },
  { icon: Container, title: "Containers", desc: "Global trade" }
];
</script>

<style scoped>
.hero-bg {
  min-height: 100vh;
  padding-top: 100px;
  background:
    radial-gradient(circle at top, rgba(0,180,255,0.18), transparent 60%),
    linear-gradient(180deg, #0b1e2d 0%, #0f2a3f 60%, #0b1e2d 100%);
  position: relative;
  overflow: hidden;
}

.hero-bg::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
  background-size: 40px 40px;
  pointer-events: none;
}

.hero-content {
  max-width: 900px;
  transform: translateY(-20px);
}

.hero-wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 120px;
}
.fleet-img {
  height: 260px;        /* adjust this */
  width: 100%;
  overflow: hidden;
}

.fleet-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;   /* magic line */
}
.industries-bg {
  background:
    radial-gradient(circle at top, rgba(0,180,255,0.18), transparent 60%),
    linear-gradient(180deg, #0b1e2d 0%, #0f2a3f 60%, #0b1e2d 100%);
}

.industry-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  backdrop-filter: blur(6px);
  transition: all 0.3s ease;
}

.industry-card:hover {
  transform: translateY(-6px);
  background: rgba(255, 255, 255, 0.1);
}

.industry-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(0, 180, 255, 0.18);
  color: #38bdf8; /* info-ish */
}

.logo-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

</style>
